import React from 'react';
import { Modal, Image } from 'antd';

type DocumentPreviewModalProps = {
  open: boolean;
  imageUrl: string;
  onClose: () => void;
};

const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({ open, imageUrl, onClose }) => (
  <Modal open={open} title="Просмотр файла" footer={null} onCancel={onClose} width={800}>
    <Image alt="preview" style={{ width: '100%' }} src={imageUrl} />
  </Modal>
);

export default DocumentPreviewModal;
